import { useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import CircularProgress from '@material-ui/core/CircularProgress';

import { type IS3Response } from 'src/models';
import { type RootState } from 'src/store';
import { useDispatch, useSelector } from 'react-redux';

import _ from 'lodash';
import sectionActions, { type Type } from 'src/store/Sections/actions';
import useStyles from './VideoUploader-styles';

interface Props {
	onUpload: (file: File) => void;
	// setDuration: (duration: number) => void;
}

function VideoUploader({ onUpload }: Props) {
	const classes = useStyles();
	// NOTE: Ver todas las notas de ./src/modules/private/Admin.tsx
	const dispatch = useDispatch();
	const [fileObjects, setFileObjects] = useState([]);
	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	const set = (key: Type, value: any) => dispatch(sectionActions.set(key, value));
	const isUploadingVideo = useSelector((state: RootState) => state.sections.isUploadingVideo);

	const onDrop = useCallback(
		(acceptedFiles) => {
			const files = acceptedFiles;
			setFileObjects(files);
		},
		[fileObjects],
	);

	const { acceptedFiles, getInputProps, getRootProps } = useDropzone({
		accept: 'video/mov, video/mp4, video/wmv, video/avi, video/mkv, video/webm',
		maxFiles: 1,
		onDrop,
	});

	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	const files = acceptedFiles.map((file: any) => <li key={file.path}>{file.path}</li>);

	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	const handleSaveFiles = async (files: File[]) => {

		try {
			set('isUploadingVideo', true);

			if (files?.length > 0) {
				onUpload(files[0]);
			}

		} catch (error) {
			console.log('Uploader Error:', error);
		} finally {
			set('isUploadingVideo', false);
		}
	};

	useEffect(() => {
		if (!_.isEmpty(fileObjects)) {
			handleSaveFiles(fileObjects);
		}
	}, [fileObjects]);

	return (
		<div className={classes.addArea}>
			<div {...getRootProps({ className: 'dropzone' })}>
				<input {...getInputProps()} />

				<p>Arrastra el archivo o da click</p>
			</div>

			<aside>
				{isUploadingVideo && <CircularProgress />}

				{files.length > 0 && !isUploadingVideo && (
					<>
						<h4>Archivos</h4>

						<ul>{files}</ul>
					</>
				)}
			</aside>
		</div>
	);
}

export default VideoUploader;
